$(document).ready(function () {

    $("#book-coupons-table").DataTable({
        proccesing: true,
        serverSide: true,
        language: {
            url: "https://cdn.datatables.net/plug-ins/2.0.3/i18n/es-ES.json"
        },
        responsive: true,
        ajax: '/admin/get-book-coupons',
        columns: [
            {data: 'id', name: 'id'},
            {data: 'description', description: 'name'},
            {data: 'book.title', description: 'book.title'},
            {data: 'code', name: 'code'},
            {data: 'type', name: 'type'},
            {data: 'value', name: 'value'},
            {data: 'fecha_inicio', name: 'fecha_inicio'},
            {data: 'fecha_fin', name: 'fecha_fin'},
        ],
        "columnDefs": [{
            "targets": 8,
            "data": "download_link",
            "render": function (data, type, row, meta) {
                let status = get_global_status(row.status);
                return '<a href="#" data-toggle="tooltip" data-placement="top" title="' + status.title + '" ' +
                    'class="btn btn-' + status.color_clas + ' change-coupon-status btn-sm m-1"  ' +
                    'data-id ="' + row.id + '"><span class="' + status.icon + '"></span></a> ' +

                    '<button data-toggle="tooltip" data-placement="top" title="Editar" class="btn button_almadia_reverse ' +
                    'edit-coupon btn-sm m-1"' +
                    'data-data ="' + row + '"><i class="far fa-edit"></i></i></button> ' + button_coupon_delete(row.status, row.id)
            }
        }]
    })

    const list_coupons = $("#book-coupons-table").DataTable()

    function button_coupon_delete(status, id) {
        if (status === "D") {
            return button = '<a href="#" data-toggle="tooltip" data-placement="top" title="Eliminar" ' +
                'class="btn btn-danger delete-coupon btn-sm m-1"  ' +
                'data-id ="' + id + '"><i class="fa-solid fa-trash-can-arrow-up"></i></a> ';
        }
        return "";
    }

    $("#add-book-coupons").on('click', function (e) {
        e.preventDefault()
        $("#text-modal-coupons").html('Asignar cupón a libro');
        $("#modal-coupons").modal('show');
        $(".item-coupon-dir").val('add');
        $("#form-book-coupons")[0].reset();
        $('.itemcode-book').val('').prop('disabled', false);
        $('.item-book_id').val('');
        initAutocomplete();
    })

    $("#book-coupons-table tbody").on('click', '.change-coupon-status', function (e) {
        e.preventDefault();
        let data = new FormData()
        data.append('id', $(this).data('id'))
        sendData(data, '/admin/update-book-coupons-status')
    })

    $("#book-coupons-table tbody").on('click', '.delete-coupon', function (e) {
        e.preventDefault();
        let data = new FormData()
        data.append('id', $(this).data('id'))
        swal.fire({
            title: "¿Estas seguro?",
            text: "Tu registro sera eliminado",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Si, eliminar!',
            cancelButtonText: 'Cancelar'
        }).then((result) => {
            if (result.isConfirmed) {
                sendData(data, '/admin/delete-book-coupon')
            }
        })
    })

    $("#book-coupons-table tbody").on('click', '.edit-coupon', function (e) {
        let data = $(this).data('data')
        $(".item-coupon-dir").val('edit')
        $("#modal-coupons").modal('show')
        $("#text-modal-coupons").html('Actualizar datos del cupón');
        rowData = list_coupons.row($(this).parents('tr')).data();
        $.each(rowData, function (index, value) {
            if (index === "type") {
                setValue(value)
            }
            $(".item-" + index).val(value)
        })

        const showTitle = `${rowData.book?.title ?? ''} | ${rowData.book?.authors_text ?? ''} | ${rowData.book?.isbn ?? ''}`;
        $(".itemcode-book").val(showTitle).prop('disabled', true);

        initAutocomplete();
    })

    $("#form-book-coupons").on('submit', function (e) {
        e.preventDefault();

        let book_id = $(".item-book_id").val();

        if (!book_id) {
            alertError('Por favor, escriba y seleccione un artículo de la lista')
            return false;
        }

        let data = new FormData(this)
        let dir = $(".item-coupon-dir").val();
        sendData(data, '/admin/' + dir + '-book-coupon', '')

    })

    function sendData(data, route) {
        $(".loader_").addClass("loading")
        $.ajax({
            url: route, type: "post", data: data, processData: false, contentType: false, headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            }, success: function (response) {

                setTimeout(function () {
                    $("#modal-coupons").modal('hide')
                    $(".loader_").removeClass("loading")
                    $("#book-coupons-table").DataTable().ajax.reload();
                    alertSuccess(response.msg)
                }, 1000)

            }, error: function (errors, xhr, status,) {
                $(".loader_").removeClass("loading")
                var indices = errors.responseJSON.errors;
                $.each(indices, function (index, value) {
                    $(".item-" + index).addClass('is-invalid')
                    $(".item-error-" + index).text(value);
                });
            }
        })
    }

    function setValue(value) {
        if (value === "Porcentaje") {
            $(".item-type_p").prop("checked", true);
            $(".item-type_m").prop("checked", false);
        } else {
            $(".item-type_m").prop("checked", true);
            $(".item-type_p").prop("checked", false);
        }
    }

    window.selectValue = function (type) {
        if (type == "Porcentaje") {
            $(".text-value-type").html('Ingresar porcentaje')
            $('.item-value').attr('placeholder', 'Ingresar porcentaje');

        } else {
            $(".text-value-type").html('Ingresar monto')
            $('.item-value').attr('placeholder', 'Ingresar monto');
        }
    }

    function initAutocomplete() {

        $("#autocomplete").autocomplete({
            source: function (request, response) {
                $(".buscando").show();

                $.ajax({
                    url: window.location.origin + "/admin/items/code/show",
                    type: "POST",
                    dataType: "json",
                    data: {
                        search: request.term,
                    },
                    headers: {
                        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                    },
                    success: function (data) {
                        $(".buscando").hide();
                        response($.map(data, function (item) {

                            const showTitle = `${item.title}  | ${item.authors_text} | ${item.isbn}`;

                            return {
                                label: showTitle,
                                item_name: showTitle,
                                value: item.id,
                            };
                        }));
                    }
                });
            },
            select: function (event, ui) {
                $('.itemcode-book').prop('disabled', true);
                $('.item-book_id').val(ui.item.value);
                $('#autocomplete').val(ui.item.item_name);

                return false;
            }
        });

        window.clearOrderDetailForm = function () {
            $('.item-book_id').val('');
            $('.item-error-itemcode').html('');
            $('.itemcode-book').val('').prop('disabled', false);
        }


    }


})
